/* VEAILIS: 360°-Ansicht, Scroll-Video und Video-Hintergrund (v8)
   - lädt je nach Gerät eine passend kleine Videodatei
   - startet erst, wenn der Bereich in Sichtweite kommt
   - entsperrt das Video auf iPhone/iPad, damit das Zerlegen in Einzelbilder klappt
   - zerlegt das Video einmal in Einzelbilder und wechselt danach nur noch Bilder */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var mobile = window.matchMedia("(max-width: 700px)").matches || /iPhone|iPad|Android/i.test(navigator.userAgent);

  function pickSrc(el) {
    var list = [];
    try { list = JSON.parse(el.getAttribute("data-srcs") || "[]"); } catch (e) {}
    if (!list.length) return null;
    list.sort(function (a, b) { return a.w - b.w; });
    var want = mobile ? 640 : 1280;
    for (var i = 0; i < list.length; i++) if (list[i].w >= want) return list[i].u;
    return list[list.length - 1].u;
  }

  function whenVisible(el, fn) {
    if (!("IntersectionObserver" in window)) return fn();
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); fn(); }
    }, { rootMargin: "400px 0px" });
    io.observe(el);
  }

  function Frames(box, video, opts) {
    this.box = box; this.video = video;
    this.canvas = document.createElement("canvas");
    this.ctx = this.canvas.getContext("2d");
    this.square = !!opts.square; this.count = opts.count; this.max = opts.max;
    this.frames = new Array(this.count); this.shown = -1; this.want = 0;
    box.appendChild(this.canvas);
  }
  Frames.prototype.size = function () {
    var v = this.video, vw = v.videoWidth, vh = v.videoHeight;
    var sw = this.square ? Math.min(vw, vh) : vw, sh = this.square ? Math.min(vw, vh) : vh;
    var w = Math.min(this.max, Math.round((this.box.clientWidth || this.max) * Math.min(window.devicePixelRatio || 1, 2)));
    this.src = { x: (vw - sw) / 2, y: (vh - sh) / 2, w: sw, h: sh };
    this.canvas.width = w; this.canvas.height = Math.round(w * sh / sw);
  };
  Frames.prototype.grab = function (i) {
    var self = this, v = this.video;
    return new Promise(function (res) {
      var t = Math.min(v.duration - 0.05, (i / self.count) * v.duration + 0.001);
      var done = false, timer;
      function snap() {
        if (done) return; done = true; clearTimeout(timer);
        v.removeEventListener("seeked", snap);
        var c = document.createElement("canvas");
        c.width = self.canvas.width; c.height = self.canvas.height;
        try { c.getContext("2d").drawImage(v, self.src.x, self.src.y, self.src.w, self.src.h, 0, 0, c.width, c.height); self.frames[i] = c; } catch (e) {}
        if (self.shown === -1 || self.want === i) self.draw(self.want);
        res();
      }
      v.addEventListener("seeked", snap);
      timer = setTimeout(snap, 700);
      v.currentTime = t;
    });
  };
  Frames.prototype.load = function () {
    var order = [], seen = {}, self = this;
    [8, 4, 2, 1].forEach(function (s) { for (var i = 0; i < self.count; i += s) if (!seen[i]) { seen[i] = 1; order.push(i); } });
    var p = Promise.resolve();
    order.forEach(function (i) { p = p.then(function () { return self.grab(i); }); });
    return p.then(function () { self.box.classList.add("is-ready"); });
  };
  Frames.prototype.nearest = function (i) {
    for (var d = 0; d < this.count; d++) {
      var a = (i + d) % this.count, b = (i - d + this.count) % this.count;
      if (this.frames[a]) return a; if (this.frames[b]) return b;
    }
    return -1;
  };
  Frames.prototype.draw = function (i) {
    this.want = i;
    var n = this.frames[i] ? i : this.nearest(i);
    if (n < 0 || n === this.shown) return;
    this.ctx.drawImage(this.frames[n], 0, 0);
    this.shown = n;
    if (!this.box.classList.contains("is-live")) this.box.classList.add("is-live");
  };
  Frames.prototype.start = function (src, cb) {
    var self = this, v = this.video;
    v.muted = true; v.setAttribute("muted", ""); v.playsInline = true;
    v.preload = "auto"; v.src = src; v.load();
    function ready() {
      /* iPhone/iPad: einmal kurz abspielen, sonst reagiert das Video nicht auf Spulen */
      var p; try { p = v.play(); } catch (e) {}
      var go = function () { try { v.pause(); } catch (e) {} self.size(); cb && cb(); self.load(); };
      if (p && p.then) p.then(go, go); else go();
    }
    if (v.readyState >= 2) ready(); else v.addEventListener("loadeddata", ready, { once: true });
  };

  /* ---------- 360° per Ziehen (ruhig und gleichmäßig) ---------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-spin]"), function (box) {
    var video = box.querySelector("video"); if (!video) return;
    var src = pickSrc(box); if (!src) return;
    var f = new Frames(box, video, { square: false, count: mobile ? 36 : 60, max: mobile ? 640 : 1100 });
    /* Empfindlichkeit: am Handy braucht eine volle Drehung 1,4 Bildbreiten Wischweg */
    var sens = mobile ? 1.4 : 1;
    var pos = 0, target = 0, vel = 0, cur = 0, down = false, lastX = 0, raf = 0, samples = [];
    function show() {
      /* Nur umschalten, wenn wirklich ein halbes Bild weiter bewegt: verhindert Zittern */
      if (Math.abs(pos - cur) > 0.6) cur = Math.round(pos);
      var i = cur % f.count; if (i < 0) i += f.count;
      f.draw(i);
    }
    function loop() {
      if (!down && vel) { target += vel; vel *= 0.9; if (Math.abs(vel) < 0.03) vel = 0; }
      pos += (target - pos) * 0.3;
      show();
      raf = (down || vel || Math.abs(target - pos) > 0.02) ? requestAnimationFrame(loop) : 0;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(loop); }
    whenVisible(box, function () { f.start(src); });
    box.addEventListener("pointerdown", function (e) {
      down = true; vel = 0; target = pos; lastX = e.clientX;
      samples = [{ t: e.timeStamp || performance.now(), x: e.clientX }];
      try { box.setPointerCapture(e.pointerId); } catch (x) {}
      box.classList.add("is-drag"); kick();
    });
    box.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - lastX; lastX = e.clientX;
      target += -dx / (box.clientWidth * sens) * f.count;
      var now = e.timeStamp || performance.now();
      samples.push({ t: now, x: e.clientX });
      while (samples.length > 2 && now - samples[0].t > 100) samples.shift();
      if (Math.abs(dx) > 2) box.classList.add("is-used");
    });
    function up(e) {
      if (!down) return;
      down = false; box.classList.remove("is-drag");
      /* Nachschwung nur bei echtem Schwung, gemittelt über die letzten 100 ms und begrenzt */
      var now = (e && e.timeStamp) || performance.now();
      var a = samples[0], b = samples[samples.length - 1];
      if (a && b && b.t > a.t && now - b.t < 80) {
        var pxPerMs = (b.x - a.x) / (b.t - a.t);
        vel = -pxPerMs * 16 / (box.clientWidth * sens) * f.count;
        var max = 0.7; if (vel > max) vel = max; if (vel < -max) vel = -max;
        if (Math.abs(vel) < 0.08) vel = 0;
      } else vel = 0;
      samples = []; kick();
    }
    box.addEventListener("pointerup", up); box.addEventListener("pointercancel", up);
    box.tabIndex = 0; box.setAttribute("role", "slider"); box.setAttribute("aria-label", "Produkt drehen");
    box.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { target += 2; kick(); e.preventDefault(); }
      if (e.key === "ArrowRight") { target -= 2; kick(); e.preventDefault(); }
    });
  });

  /* ---------- Scroll-Video ---------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-sv]"), function (sec) {
    var box = sec.querySelector(".sv__stick"), video = box && box.querySelector("video"); if (!video) return;
    var src = pickSrc(sec); if (!src) return;
    var f = new Frames(box, video, { square: false, count: mobile ? 40 : 72, max: mobile ? 540 : 1000 });
    var pos = 0, target = 0, raf = 0, started = false;
    function measure() {
      var total = sec.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -sec.getBoundingClientRect().top / total)) : 0;
      target = p * (f.count - 1);
    }
    function loop() {
      pos += (target - pos) * (reduce ? 1 : 0.2);
      f.draw(Math.round(pos));
      raf = Math.abs(target - pos) > 0.05 ? requestAnimationFrame(loop) : 0;
    }
    function onScroll() { if (!started) return; measure(); if (!raf) raf = requestAnimationFrame(loop); }
    whenVisible(sec, function () { f.start(src, function () { started = true; measure(); pos = target; f.draw(Math.round(pos)); }); });
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  });

  /* ---------- Video im Hintergrund (Endlosschleife) ---------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-bgv]"), function (sec) {
    var v = sec.querySelector("video"); if (!v) return;
    var src = pickSrc(sec); if (!src) return;
    v.muted = true; v.setAttribute("muted", ""); v.playsInline = true; v.loop = true;
    if (reduce) { v.removeAttribute("autoplay"); return; }
    var loaded = false;
    function play() { var p; try { p = v.play(); } catch (e) {} if (p && p.catch) p.catch(function () {}); }
    if (!("IntersectionObserver" in window)) { v.src = src; play(); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { if (!loaded) { loaded = true; v.src = src; } play(); }
        else if (loaded) { v.pause(); }
      });
    }, { rootMargin: "200px 0px" }).observe(sec);
  });
})();
